function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

if (typeof window.APPSTLE_DEBUG_ENABLED === 'undefined') {
  window.APPSTLE_DEBUG_ENABLED = true;
  window.APPSTLE_DEBUG_ENTRIES = [];
}

function appstleDebugLog(sectionId, label, payload) {
  if (!window.APPSTLE_DEBUG_ENABLED) return;

  const entry = {
    time: new Date().toISOString(),
    section: sectionId || 'unknown',
    label: label,
    payload: payload || null
  };

  window.APPSTLE_DEBUG_ENTRIES.push(entry);

  try {
    if (payload !== undefined && payload !== null) {
      console.log('[AppstleDebug][' + entry.section + '] ' + label, payload);
    } else {
      console.log('[AppstleDebug][' + entry.section + '] ' + label);
    }
  } catch (err) {
    // Swallow console errors to avoid breaking execution in older browsers
  }
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        detailsElement.setAttribute('open', true);
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    // Clear any cart operation flags on product page load to prevent cross-page contamination
    window.cartOperationInProgress = false;
  }

  connectedCallback() {
    // Clear cart operation flag to ensure clean state on component connection
    window.cartOperationInProgress = false;

    // Initialize subscription listeners when element is connected to DOM
    this.initializeSubscriptionListeners();

    // Ensure we have the current variant for initial price calculation
    this.updateOptions();
    this.updateMasterId();

    // Force initial price update immediately to ensure product price is shown
    setTimeout(() => {
      if (this.currentVariant) {
        // Force price update with clean state - ignore any cart operation flags for initial load
        const previousCartFlag = window.cartOperationInProgress;
        window.cartOperationInProgress = false;
        this.updateButtonPrice(false);  // false = don't multiply by quantity, show single unit price
        this.cacheVariantPricingFromDom();
        this.updateAppstleOneTimePricing();
        window.cartOperationInProgress = previousCartFlag;
      }
    }, 100);

    // Reset quantity to 1 on product page load to prevent cart contamination
    setTimeout(() => {
      // Reset all quantity inputs for THIS product section to 1 (avoid cart inputs)
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const sectionRoot = document.getElementById(`ProductInfo-${this.dataset.section}`);
      const candidates = [];

      if (sectionRoot) {
        candidates.push(
          ...Array.from(sectionRoot.querySelectorAll('input[name="quantity"], .quantity__input, quantity-input input, input[id*="Quantity-"]'))
        );
      }

      if (productForm) {
        candidates.push(
          ...Array.from(document.querySelectorAll(`input[name="quantity"][form="${productForm.id}"]`))
        );
        // Also include any quantity inputs that are actual descendants (in case markup differs)
        candidates.push(
          ...Array.from(productForm.querySelectorAll('input[name="quantity"], .quantity__input, quantity-input input, input[id*="Quantity-"]'))
        );
      }

      // Filter out duplicates and any inputs inside cart contexts
      const seen = new Set();
      const quantityInputs = candidates.filter(inp => {
        if (!inp || !(inp instanceof HTMLElement)) return false;
        if (inp.closest('cart-items, cart-drawer-items, .cart-item')) return false;
        if (seen.has(inp)) return false;
        seen.add(inp);
        return true;
      });

      quantityInputs.forEach(input => {
        if (String(input.value) !== '1') {
          input.value = 1;
          // Trigger input event to ensure any listeners update
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      // Update button price again after quantity reset to ensure correct calculation
      if (this.currentVariant) {
        this.updateButtonPrice(false);  // false = show single unit price, not multiplied by quantity
        this.cacheVariantPricingFromDom();
        this.updateAppstleOneTimePricing();
      }
    }, 500);
  }

  onVariantChange() {
    // Clear any cart contamination flags when variant changes
    window.cartOperationInProgress = false;

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateAppstleOneTimePricing();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (!variant || !variant.options || !this.options) return false;

      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    // Fallback: if we couldn't find variant by options, try to get it from the hidden input
    if (!this.currentVariant) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (productForm) {
        const hiddenInput = productForm.querySelector('input[name="id"]');
        if (hiddenInput && hiddenInput.value) {
          this.currentVariant = this.getVariantData().find(variant => variant.id == hiddenInput.value);
        }
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          this.cacheVariantPricingFromDom(destination);
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        // Update button price after setting button state to ensure price persists - use false to show single unit price
        this.updateButtonPrice(false);
        this.updateAppstleOneTimePricing();
        setTimeout(() => this.updateAppstleOneTimePricing(), 150);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        // Clear existing content and set new text
        addButtonText.innerHTML = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      // Preserve existing price element when setting add to cart text
      const existingPrice = addButtonText.querySelector('.pro-price');
      const priceHTML = existingPrice ? existingPrice.outerHTML : '';
      addButtonText.innerHTML = window.variantStrings.addToCart + ' ' + priceHTML;
    }

    if (!modifyClass) return;
  }

  updateButtonPrice(forceQuantityCalculation = false) {
    try {
      const sectionId = this.dataset ? this.dataset.section : 'unknown';
      appstleDebugLog(sectionId, 'updateButtonPrice:start', {
        forceQuantityCalculation: !!forceQuantityCalculation,
        cartFlag: !!window.cartOperationInProgress
      });

      // Skip price updates if cart operations are in progress to avoid contamination
      if (window.cartOperationInProgress) {
        appstleDebugLog(sectionId, 'updateButtonPrice:skip-cart-flag');
        return;
      }

      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) {
        console.warn('Product form not found for price update');
        appstleDebugLog(sectionId, 'updateButtonPrice:no-product-form');
        return;
      }

      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButtonText) {
        console.warn('Add button text element not found for price update');
        appstleDebugLog(sectionId, 'updateButtonPrice:no-add-button-text');
        return;
      }

      let priceElement = addButtonText.querySelector('.pro-price');

      if (this.currentVariant && this.currentVariant.available) {
        appstleDebugLog(sectionId, 'updateButtonPrice:variant-available', {
          variantId: this.currentVariant.id,
          quantityForced: !!forceQuantityCalculation
        });

        // Check if subscription is selected and get the subscription price
        const subscriptionPrice = this.getSubscriptionPrice();
        const unitPrice = subscriptionPrice || this.currentVariant.price;

        if (subscriptionPrice) {
          appstleDebugLog(sectionId, 'updateButtonPrice:using-subscription-price', {
            subscriptionPrice: subscriptionPrice,
            variantPrice: this.currentVariant.price
          });
        }

        // Enhanced quantity detection - try multiple methods to find quantity input
        let quantityInput = null;
        let quantity = 1;

        // Robust quantity input resolution limited to THIS section/form
        const sectionRoot = document.getElementById(`ProductInfo-${this.dataset.section}`);
        const candidateLists = [];
        if (sectionRoot) {
          candidateLists.push(Array.from(sectionRoot.querySelectorAll('input[name="quantity"], .quantity__input, quantity-input input, input[id*="Quantity-"]')));
        }
        // Inputs explicitly tied to the form via the HTML 'form' attribute (common in Shopify markup)
        candidateLists.push(Array.from(document.querySelectorAll(`input[name="quantity"][form="${productForm.id}"]`)));
        // As a last resort, search within the form DOM
        candidateLists.push(Array.from(productForm.querySelectorAll('input[name="quantity"], .quantity__input, quantity-input input, input[id*="Quantity-"]')));

        const flatCandidates = candidateLists.flat();
        quantityInput = flatCandidates.find(inp => inp instanceof HTMLElement && !inp.closest('cart-items, cart-drawer-items, .cart-item')) || null;

        // Only multiply by quantity if we're explicitly told to (after user interaction)
        // or if the quantity is not 1 (meaning user has changed it)
        if (quantityInput) {
          const inputValue = parseInt(quantityInput.value, 10);
          const safeValue = (!isNaN(inputValue) && inputValue > 0 && inputValue <= 100) ? inputValue : 1;

          if (forceQuantityCalculation || safeValue > 1) {
            quantity = safeValue;
          }
          appstleDebugLog(sectionId, 'updateButtonPrice:quantity-detected', {
            rawValue: inputValue,
            appliedQuantity: quantity,
            forced: !!forceQuantityCalculation
          });
        }

        // For initial load, show single unit price. For quantity changes, multiply.
        const totalPrice = unitPrice * quantity;
        const formattedPrice = this.formatMoney(totalPrice);

        if (!priceElement) {
          // Create price element if it doesn not exist
          priceElement = document.createElement('span');
          priceElement.className = 'pro-price';
          addButtonText.appendChild(priceElement);
        }
        priceElement.textContent = formattedPrice;
        appstleDebugLog(sectionId, 'updateButtonPrice:price-updated', {
          totalPrice: totalPrice,
          formatted: formattedPrice
        });
      } else {
        // Remove price element if variant is not available
        if (priceElement) {
          priceElement.remove();
        }
        appstleDebugLog(sectionId, 'updateButtonPrice:variant-unavailable');
      }

      this.updateAppstleOneTimePricing();
    } catch (error) {
      console.error('Error updating button price:', error);
      const sectionId = this.dataset ? this.dataset.section : 'unknown';
      appstleDebugLog(sectionId, 'updateButtonPrice:error', {
        message: error && error.message ? error.message : 'unknown',
        stack: error && error.stack ? error.stack : null
      });
    }
  }

  getSubscriptionPrice() {
    // Scope to THIS product section to avoid picking up unrelated widgets/totals
    const sectionRoot = document.getElementById(`ProductInfo-${this.dataset.section}`);
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const contextRoot = sectionRoot || productForm || this;

    // Look for Appstle widget only within the context root
    const appstleWidget = contextRoot.querySelector('#appstle_subscription_widget0, [id*="appstle"], .appstle_subscription_wrapper');
    if (!appstleWidget) return null;

    // Check if subscription option is selected for THIS product
    const selectedSubscriptionOption = appstleWidget.querySelector('.appstle_subscription_wrapper_option.appstle-active-option, input[name*="appstle"]:checked, input[name*="subscription"]:checked');
    if (!selectedSubscriptionOption) return null;

    let subscriptionPrice = null;

    // Method 1: Reliable data attribute on selected option
    if (selectedSubscriptionOption.dataset.price) {
      const parsed = parseFloat(selectedSubscriptionOption.dataset.price);
      if (!isNaN(parsed) && isFinite(parsed)) subscriptionPrice = parsed * 100; // cents
    }

    // Method 2: Specific child element within the widget that displays the subscription price
    if (!subscriptionPrice) {
      const priceNode = selectedSubscriptionOption.querySelector('[data-price], .appstle_subscription_price, .appstle_option_price, .appstle_display_price');
      if (priceNode) {
        const dataAttr = priceNode.getAttribute('data-price');
        if (dataAttr) {
          const parsed = parseFloat(dataAttr);
          if (!isNaN(parsed) && isFinite(parsed)) subscriptionPrice = parsed * 100;
        } else {
          const text = priceNode.textContent || '';
          const m = text.replace(/,/g, '').match(/\$(\d+(?:\.\d{2})?)/);
          if (m) {
            const parsed = parseFloat(m[1]);
            if (!isNaN(parsed) && isFinite(parsed)) subscriptionPrice = parsed * 100;
          }
        }
      }
    }

    // Method 3: As a last resort, parse the selected option's own text but avoid cart-related words
    if (!subscriptionPrice) {
      const priceText = (selectedSubscriptionOption.textContent || selectedSubscriptionOption.innerText || '').replace(/,/g, '');
      if (!/subtotal|total|cart/i.test(priceText)) {
        const priceMatch = priceText.match(/\$(\d+(?:\.\d{2})?)/);
        if (priceMatch) {
          const parsed = parseFloat(priceMatch[1]);
          if (!isNaN(parsed) && isFinite(parsed)) subscriptionPrice = parsed * 100;
        }
      }
    }

    // Method 4: Discount percentage from widget relative to current variant price
    if (!subscriptionPrice) {
      const percentCarrier = selectedSubscriptionOption.closest('[data-discount-percentage]') || selectedSubscriptionOption;
      const discountPercent = percentCarrier.dataset.discountPercentage || percentCarrier.dataset.discount || null;
      if (discountPercent && this.currentVariant) {
        const discount = parseFloat(discountPercent) / 100;
        if (!isNaN(discount) && discount > 0 && discount < 1) {
          subscriptionPrice = Math.round(this.currentVariant.price * (1 - discount));
        }
      }
    }

    // Method 5: Shopify native selling plan allocations in context of this form
    if (!subscriptionPrice && this.currentVariant && this.currentVariant.selling_plan_allocations) {
      const activePlan = this.currentVariant.selling_plan_allocations.find(plan => {
        const planInput = contextRoot.querySelector(`input[name="selling_plan"][value="${plan.selling_plan.id}"]:checked`);
        return !!planInput;
      });
      if (activePlan) subscriptionPrice = activePlan.price;
    }

    // Safety: guard against implausible values (e.g., accidentally using cart totals)
    if (subscriptionPrice && this.currentVariant && subscriptionPrice > this.currentVariant.price * 2) {
      // Subscription should not be more than 2x one-time price; treat as invalid
      subscriptionPrice = null;
    }

    return subscriptionPrice;
  }

  initializeSubscriptionListeners() {
    // Listen for Appstle widget changes
    const appstleWidget = document.querySelector('#appstle_subscription_widget0, [id*="appstle"], .appstle_subscription_wrapper');
    if (appstleWidget) {
      // Listen for clicks on subscription options
      appstleWidget.addEventListener('click', (event) => {
        if (event.target.matches('.appstle_subscription_wrapper_option, input[name*="appstle"], input[name*="subscription"]')) {
          // Delay to ensure the selection state is updated
          setTimeout(() => {
            this.updateButtonPrice(true);
          }, 100);
        }
      });

      // Listen for change events on inputs
      appstleWidget.addEventListener('change', (event) => {
        if (event.target.matches('input[name*="appstle"], input[name*="subscription"], input[name="selling_plan"]')) {
          setTimeout(() => {
            this.updateButtonPrice(true);
          }, 100);
        }
      });
    }

    // Listen for selling plan changes (Shopify native subscriptions)
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="selling_plan"]')) {
        setTimeout(() => {
          this.updateButtonPrice(true);
        }, 100);
      }
    });

    // Listen for custom Appstle events (they might fire custom events)
    document.addEventListener('appstleSubscriptionChanged', () => {
      this.updateButtonPrice(true);
    });

    // Listen for MutationObserver to catch dynamic changes
    if (appstleWidget) {
      this._appstleMutationObserver = new MutationObserver((mutations) => {
        if (this._suspendAppstleObserver) {
          const sectionId = this.dataset ? this.dataset.section : 'unknown';
          appstleDebugLog(sectionId, 'observer:mutations-ignored-suspended', {
            count: mutations.length
          });
          return;
        }

        mutations.forEach((mutation) => {
          if (mutation.type !== 'attributes') return;
          if (mutation.attributeName !== 'class' && mutation.attributeName !== 'data-selected') return;

          const targetElement = mutation.target instanceof Element ? mutation.target : (mutation.target && mutation.target.parentElement);
          if (!targetElement) return;

          if (targetElement.classList && targetElement.classList.contains('one_time_discount')) return;
          if (targetElement.hasAttribute && targetElement.hasAttribute('data-appstle-one-time-badge')) return;
          if (targetElement.closest && targetElement.closest('[data-appstle-one-time-badge]')) return;
          if (!(targetElement.closest && targetElement.closest('.appstle_subscription_wrapper_option'))) return;

          const sectionId = this.dataset ? this.dataset.section : 'unknown';
          appstleDebugLog(sectionId, 'observer:mutation-trigger', {
            attribute: mutation.attributeName,
            targetClasses: targetElement.className
          });
          this.updateButtonPrice(true);
        });
      });

      this._appstleObserverTarget = appstleWidget;
      this._appstleObserverConfig = {
        attributes: true,
        childList: true,
        subtree: true
      };
      this._appstleMutationObserver.observe(appstleWidget, this._appstleObserverConfig);
    }

    this.updateAppstleOneTimePricing();
  }

  formatMoney(cents) {
    // Convert cents to dollars and keep standard 2 decimal places
    const dollars = cents / 100;

    // Always show two decimals for price consistency
    const formatted = dollars.toFixed(2);

    // Return with dollar sign (adjust if currency formatting changes)
    return '$' + formatted;
  }

  parseMoneyToCents(value) {
    if (value === null || value === undefined) return null;
    if (typeof value === 'number' && isFinite(value)) {
      const asInt = Math.round(value);
      if (String(value).includes('.')) {
        return Math.round(value * 100);
      }
      return asInt;
    }

    const raw = String(value)
      .replace(/[^0-9.,-]/g, '')
      .replace(/,/g, '')
      .trim();

    if (!raw) return null;

    const parsed = parseFloat(raw);
    if (isNaN(parsed) || !isFinite(parsed)) return null;

    const hasDecimal = raw.indexOf('.') !== -1;
    if (!hasDecimal && parsed > 1000) {
      return Math.round(parsed);
    }

    return Math.round(parsed * 100);
  }

  cacheVariantPricingFromDom(contextRoot) {
    if (!this.currentVariant) return;

    const sectionId = this.dataset ? this.dataset.section : 'unknown';

    let priceRoot = contextRoot || document.getElementById(`price-${this.dataset.section}`);
    if (!priceRoot && this.dataset && this.dataset.section) {
      const sectionElm = document.querySelector(`[data-section="${this.dataset.section}"]`);
      if (sectionElm) {
        priceRoot = sectionElm.querySelector(`#price-${this.dataset.section}`) || sectionElm.querySelector('.price, [data-product-price]');
      }
    }

    if (!priceRoot) {
      priceRoot = document.querySelector(`#MainProduct-${this.dataset.section} .price, #MainProduct-${this.dataset.section} [data-product-price]`);
    }

    if (!priceRoot) {
      appstleDebugLog(sectionId, 'cacheVariantPricingFromDom:no-root');
      return;
    }

    const compareNode = priceRoot.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--compare, .price__sale .price-item--regular');
    const saleNode = priceRoot.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--sale, .price-item--regular');

    const parsedCompare = compareNode ? this.parseMoneyToCents(compareNode.textContent) : null;
    const parsedPrice = saleNode ? this.parseMoneyToCents(saleNode.textContent) : null;

    if (parsedPrice && isFinite(parsedPrice)) {
      this.currentVariant.price = parsedPrice;
    }

    if (parsedCompare && parsedCompare > (this.currentVariant.price || 0)) {
      this.currentVariant.compare_at_price = parsedCompare;
      appstleDebugLog(sectionId, 'cacheVariantPricingFromDom:set', {
        compareCents: parsedCompare
      });
    } else {
      appstleDebugLog(sectionId, 'cacheVariantPricingFromDom:no-compare', {
        parsedCompare,
        variantPrice: this.currentVariant.price
      });
    }
  }

  resolveCompareAtPrice(variantPrice, contextRoot) {
    const sectionId = this.dataset ? this.dataset.section : 'unknown';

    if (this.currentVariant && this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > variantPrice) {
      appstleDebugLog(sectionId, 'resolveCompareAtPrice:variant-data', {
        variantCompareAt: this.currentVariant.compare_at_price,
        variantPrice
      });
      return this.currentVariant.compare_at_price;
    }

    const priceSection = document.getElementById(`price-${this.dataset.section}`);
    let priceContainer = priceSection || (contextRoot && contextRoot.querySelector('.price, [data-product-price]'));

    if (!priceContainer) {
      const sectionElement = document.querySelector(`[data-section="${this.dataset.section}"]`);
      if (sectionElement) {
        priceContainer = sectionElement.querySelector(`#price-${this.dataset.section}`) || sectionElement.querySelector('.price, [data-product-price]');
      }
    }

    if (!priceContainer) {
      priceContainer = document.querySelector(`#MainProduct-${this.dataset.section} .price, #MainProduct-${this.dataset.section} [data-product-price]`);
    }

    if (!priceContainer) {
      appstleDebugLog(sectionId, 'resolveCompareAtPrice:no-price-container');
      if (this.currentVariant) {
        appstleDebugLog(sectionId, 'resolveCompareAtPrice:variant-snapshot', {
          variantId: this.currentVariant.id,
          price: this.currentVariant.price,
          compare_at_price: this.currentVariant.compare_at_price,
          compare_at_price_max: this.currentVariant.compare_at_price_max || null
        });
      }
      return null;
    }

    this.cacheVariantPricingFromDom(priceContainer);

    let compareCents = null;

    const datasetValue = priceContainer.dataset ? (priceContainer.dataset.comparePrice || priceContainer.dataset.compareAtPrice) : null;
    if (datasetValue) {
      const parsedDataset = this.parseMoneyToCents(datasetValue);
      if (parsedDataset && parsedDataset > variantPrice) {
        compareCents = parsedDataset;
      }
    }

    if (!compareCents) {
      const compareNode = priceContainer.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--compare, .price__sale .price-item--regular');
      if (compareNode) {
        const parsedNode = this.parseMoneyToCents(compareNode.textContent);
        if (parsedNode && parsedNode > variantPrice) {
          compareCents = parsedNode;
        }
      }
    }

    if (!compareCents) {
      const fallbackAttr = priceContainer.getAttribute('data-price-compare') || priceContainer.getAttribute('data-original-price');
      if (fallbackAttr) {
        const parsedAttr = this.parseMoneyToCents(fallbackAttr);
        if (parsedAttr && parsedAttr > variantPrice) {
          compareCents = parsedAttr;
        }
      }
    }

    if (compareCents && compareCents > variantPrice) {
      appstleDebugLog(sectionId, 'resolveCompareAtPrice:dom-fallback', {
        compareCents
      });
      return compareCents;
    }

    appstleDebugLog(sectionId, 'resolveCompareAtPrice:compare-missing', {
      variantPrice
    });
    return null;
  }

  updateAppstleOneTimePricing() {
    const sectionId = this.dataset ? this.dataset.section : 'unknown';
    if (this._appstleUpdating) {
      appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:skip-busy');
      return;
    }
    this._appstleUpdating = true;
    this._suspendAppstleObserver = true;
    let observerWasActive = false;
    if (this._appstleMutationObserver && this._appstleObserverTarget) {
      try {
        this._appstleMutationObserver.disconnect();
        observerWasActive = true;
        appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:observer-disconnected');
      } catch (disconnectError) {
        appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:observer-disconnect-error', {
          message: disconnectError && disconnectError.message ? disconnectError.message : 'unknown'
        });
      }
    }
    try {
      if (!this.currentVariant) {
        appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:no-variant');
        return;
      }

      const sectionRoot = document.getElementById(`ProductInfo-${this.dataset.section}`);
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const fallbackRoot = this.closest ? this.closest('section, form, .product, .product-section') : null;
      const contextRoot = sectionRoot || productForm || fallbackRoot || this;

      const widget = contextRoot.querySelector('#appstle_subscription_widget0, [id*="appstle"], .appstle_subscription_wrapper');
      if (!widget) {
        appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:no-widget');
        return;
      }

      const variantPrice = this.currentVariant.price;
      const compareAt = this.resolveCompareAtPrice(variantPrice, contextRoot) || 0;

      appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:start', {
        variantId: this.currentVariant.id,
        variantPrice: variantPrice,
        compareAt: compareAt
      });

      const oneTimeWrappers = widget.querySelectorAll('.appstle_one_time_price_wrapper');
      if (!oneTimeWrappers.length) {
        appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:no-one-time-wrapper');
        this._appstleWrapperRetries = (this._appstleWrapperRetries || 0) + 1;
        if (this._appstleWrapperRetries <= 6) {
          const retryDelay = 100 * this._appstleWrapperRetries;
          setTimeout(() => {
            appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:retry-wrapper', {
              attempt: this._appstleWrapperRetries,
              delay: retryDelay
            });
            this.updateAppstleOneTimePricing();
          }, retryDelay);
        }
        return;
      }

      this._appstleWrapperRetries = 0;

      oneTimeWrappers.forEach((oneTimeWrapper) => {
        let priceEl = oneTimeWrapper.querySelector('.appstle_subscription_amount');
        if (!priceEl) {
          priceEl = document.createElement('span');
          priceEl.className = 'appstle_subscription_amount transcy-money';
          oneTimeWrapper.prepend(priceEl);
        }

        let srPriceEl = oneTimeWrapper.querySelector('.appstle_subscription_amount-appstle-sr-only');
        if (!srPriceEl) {
          srPriceEl = document.createElement('span');
          srPriceEl.className = 'appstle_subscription_amount-appstle-sr-only transcy-money sr-only';
          oneTimeWrapper.appendChild(srPriceEl);
        }

        let compareEl = oneTimeWrapper.querySelector('.appstle_subscription_amount_compare_at_price');
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'appstle_subscription_amount_compare_at_price transcy-money';
          oneTimeWrapper.appendChild(compareEl);
        }

        let srCompareEl = oneTimeWrapper.querySelector('.appstle_subscription_amount_compare_at_price-appstle-sr-only');
        if (!srCompareEl) {
          srCompareEl = document.createElement('span');
          srCompareEl.className = 'appstle_subscription_amount_compare_at_price-appstle-sr-only transcy-money sr-only';
          oneTimeWrapper.appendChild(srCompareEl);
        }

        const optionContainer = oneTimeWrapper.closest('.appstle_one_time_details_wrapper, .appstle_subscription_wrapper_option') || widget;
        const label = optionContainer ? optionContainer.querySelector('label.appstle_radio_label') : null;
        let textWrapper = label ? label.querySelector('.appstle-text-and-badge-wrapper') : null;

        if (label) {
          if (!textWrapper) {
            textWrapper = document.createElement('span');
            textWrapper.className = 'appstle-text-and-badge-wrapper appstle-one-time-text-wrapper';
            const circle = label.querySelector('.appstle_circle');
            if (circle && circle.nextSibling) {
              label.insertBefore(textWrapper, circle.nextSibling);
            } else {
              label.appendChild(textWrapper);
            }
          } else {
            textWrapper.classList.add('appstle-one-time-text-wrapper');
          }

          const oneTimeText = label.querySelector('.appstle_one_time_text');
          if (oneTimeText && oneTimeText.parentElement !== textWrapper) {
            textWrapper.insertBefore(oneTimeText, textWrapper.firstChild);
          } else if (!oneTimeText) {
            const fallbackText = document.createElement('span');
            fallbackText.className = 'appstle_one_time_text';
            fallbackText.textContent = 'One Time Purchase';
            textWrapper.insertBefore(fallbackText, textWrapper.firstChild);
          }
        }

        let badgeEl = textWrapper ? textWrapper.querySelector('.appstle-save-badge.appstle-one-time-badge') : null;
        if (!badgeEl && optionContainer) {
          const legacyBadge = optionContainer.querySelector('.appstle_bundle_discount_amount.one_time_discount');
          if (legacyBadge) {
            badgeEl = legacyBadge;
          }
        }
        if (!badgeEl) {
          badgeEl = document.createElement('span');
        }

        badgeEl.classList.add('appstle-save-badge', 'appstle-one-time-badge');
        badgeEl.classList.remove('appstle_bundle_discount_amount', 'one_time_discount');
        badgeEl.setAttribute('data-appstle-one-time-badge', 'true');

        if (textWrapper) {
          if (badgeEl.parentElement !== textWrapper) {
            textWrapper.appendChild(badgeEl);
          }
        } else if (label) {
          if (badgeEl.parentElement !== label) {
            label.appendChild(badgeEl);
          }
        } else if (optionContainer && badgeEl.parentElement !== optionContainer) {
          optionContainer.appendChild(badgeEl);
        }

        const formattedPrice = this.formatMoney(variantPrice);
        if (priceEl.textContent !== formattedPrice) {
          priceEl.textContent = formattedPrice;
        }

        appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:price-el', {
          formatted: formattedPrice
        });

        const srFormattedPrice = `Sale price ${formattedPrice}`;
        if (srPriceEl.textContent !== srFormattedPrice) {
          srPriceEl.textContent = srFormattedPrice;
        }

        if (compareAt && compareAt > variantPrice) {
          const formattedCompare = this.formatMoney(compareAt);
          if (compareEl.textContent !== formattedCompare) {
            compareEl.textContent = formattedCompare;
          }
          if (compareEl.style.display !== 'inline-block') {
            compareEl.style.display = 'inline-block';
          }

          const srFormattedCompare = `Original price ${formattedCompare}`;
          if (srCompareEl.textContent !== srFormattedCompare) {
            srCompareEl.textContent = srFormattedCompare;
          }

          const rawPercent = ((compareAt - variantPrice) / compareAt) * 100;
          const discountPercent = Math.max(1, Math.round(rawPercent));
          const badgeLabel = `SAVE ${discountPercent}%`;
          if (badgeEl.textContent !== badgeLabel) {
            badgeEl.textContent = badgeLabel;
          }
          badgeEl.classList.add('appstle-save-badge', 'appstle-one-time-badge');
          badgeEl.setAttribute('data-appstle-one-time-badge', 'true');
          if (badgeEl.style.display !== 'inline-block') {
            badgeEl.style.display = 'inline-block';
          }

          appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:compare-at-visible', {
            badge: badgeLabel
          });
        } else {
          if (compareEl.textContent !== '') {
            compareEl.textContent = '';
          }
          if (compareEl.style.display !== 'none') {
            compareEl.style.display = 'none';
          }

          if (srCompareEl.textContent !== '') {
            srCompareEl.textContent = '';
          }

          badgeEl.textContent = '';
          badgeEl.classList.remove('appstle-save-badge', 'appstle-one-time-badge');
          if (badgeEl.style.display !== 'none') {
            badgeEl.style.display = 'none';
          }
          badgeEl.removeAttribute('data-appstle-one-time-badge');

          appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:compare-at-hidden');
        }
      });
    } catch (error) {
      console.warn('Appstle one-time price sync failed', error);
      appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:error', {
        message: error && error.message ? error.message : 'unknown',
        stack: error && error.stack ? error.stack : null
      });
    } finally {
      this._appstleUpdating = false;
      this._suspendAppstleObserver = false;
      if (observerWasActive && this._appstleMutationObserver && this._appstleObserverTarget && this._appstleObserverConfig) {
        try {
          this._appstleMutationObserver.observe(this._appstleObserverTarget, this._appstleObserverConfig);
          appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:observer-reconnected');
        } catch (observeError) {
          appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:observer-reconnect-error', {
            message: observeError && observeError.message ? observeError.message : 'unknown'
          });
        }
      }
      appstleDebugLog(sectionId, 'updateAppstleOneTimePricing:complete', {
        suspended: !!this._suspendAppstleObserver
      });
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;

    // Set unavailable text and remove price
    addButtonText.innerHTML = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    }).filter(value => value !== null); // Remove null values
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Minimal fallback: for sections with no variant picker and no quantity input,
// update the Add to Cart button price only when subscription selection changes.
(() => {
  const parseCentsFromText = (text) => {
    if (!text) return null;
    const cleaned = String(text).replace(/,/g, '');
    const m = cleaned.match(/\$(\d+(?:\.\d{1,2})?)/);
    if (!m) return null;
    const v = parseFloat(m[1]);
    if (isNaN(v) || !isFinite(v)) return null;
    return Math.round(v * 100);
  };

  const formatCents = (cents) => {
    const dollars = (cents || 0) / 100;
    return '$' + dollars.toFixed(2);
  };

  const getSectionId = (sectionRoot) => {
    const id = sectionRoot && sectionRoot.id || '';
    const m = id.match(/^ProductInfo-(.+)$/);
    return m ? m[1] : null;
  };

  const getOneTimePriceCents = (sectionRoot) => {
    const sectionId = getSectionId(sectionRoot);
    const priceRoot = (sectionId && document.getElementById(`price-${sectionId}`)) || sectionRoot.querySelector('.price');
    if (!priceRoot) return null;
    const el = priceRoot.querySelector('.price-item--sale, .price-item--regular') || priceRoot;
    return parseCentsFromText(el.textContent);
  };

  const getSubscriptionPriceCents = (sectionRoot) => {
    const widget = sectionRoot.querySelector('.appstle_subscription_wrapper, [id*="appstle"], #appstle_subscription_widget0');
    if (!widget) return null;
    // Selected option containers or inputs
    const selected = widget.querySelector('.appstle_subscription_wrapper_option.appstle-active-option, input[name*="appstle"]:checked, input[name*="subscription"]:checked');
    if (!selected) return null;

    // Prefer data-price attribute (in dollars)
    if (selected.dataset && selected.dataset.price) {
      const p = parseFloat(selected.dataset.price);
      if (!isNaN(p) && isFinite(p)) return Math.round(p * 100);
    }

    // Look for a child node with price content
    const priceNode = selected.querySelector('[data-price], .appstle_subscription_price, .appstle_option_price, .appstle_display_price');
    if (priceNode) {
      const attr = priceNode.getAttribute('data-price');
      if (attr) {
        const p = parseFloat(attr);
        if (!isNaN(p) && isFinite(p)) return Math.round(p * 100);
      }
      const cents = parseCentsFromText(priceNode.textContent);
      if (typeof cents === 'number') return cents;
    }

    // As a last resort parse the selected option text for a $ amount
    const cents = parseCentsFromText(selected.textContent || '');
    return typeof cents === 'number' ? cents : null;
  };

  const wireSection = (sectionRoot) => {
    // Only apply to sections with no variant picker AND no quantity input
    const hasVariantPicker = !!sectionRoot.querySelector('variant-selects, variant-radios');
    const hasQty = !!sectionRoot.querySelector('input[name="quantity"], .quantity__input, quantity-input input');
    if (hasVariantPicker || hasQty) return;

    const sectionId = getSectionId(sectionRoot);
    if (!sectionId) return;
    const productForm = document.getElementById(`product-form-${sectionId}`) || sectionRoot.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButtonText) return;

    const widget = sectionRoot.querySelector('.appstle_subscription_wrapper, [id*="appstle"], #appstle_subscription_widget0');
    if (!widget) return;

    // Only update price in response to an actual subscription selection change.
    const updateFromSubscription = () => {
      // Try to get the subscription price
      let cents = getSubscriptionPriceCents(sectionRoot);

      // Derive a reliable one-time price baseline: prefer existing button price, then page price block
      const existingBtnPriceEl = addButtonText.querySelector('.pro-price');
      const existingBtnCents = existingBtnPriceEl ? parseCentsFromText(existingBtnPriceEl.textContent) : null;
      const oneTimeCents = (typeof existingBtnCents === 'number') ? existingBtnCents : getOneTimePriceCents(sectionRoot);

      // If both sources failed, do not override anything
      if (typeof cents !== 'number' && typeof oneTimeCents !== 'number') {
        return;
      }

      // If we parsed an implausible subscription price, fall back to one-time
      if (typeof oneTimeCents === 'number' && typeof cents === 'number') {
        const minOk = Math.round(oneTimeCents * 0.4);
        const maxOk = Math.round(oneTimeCents * 2);
        if (cents < minOk || cents > maxOk) cents = oneTimeCents;
      }

      if (typeof cents !== 'number') cents = oneTimeCents;
      if (typeof cents !== 'number') return; // safety

      let priceEl = addButtonText.querySelector('.pro-price');
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceEl.className = 'pro-price';
        addButtonText.appendChild(priceEl);
      }
      priceEl.textContent = formatCents(cents);
    };

    const onChange = () => setTimeout(updateFromSubscription, 60);
    widget.addEventListener('change', onChange);
    widget.addEventListener('click', onChange);

    // If the widget renders late, observe and wire once available; do NOT force an initial update
    const mo = new MutationObserver(() => {
      const w = sectionRoot.querySelector('.appstle_subscription_wrapper, [id*="appstle"], #appstle_subscription_widget0');
      if (w) {
        w.addEventListener('change', onChange);
        w.addEventListener('click', onChange);
        mo.disconnect();
      }
    });
    mo.observe(sectionRoot, { childList: true, subtree: true });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="ProductInfo-"]').forEach(wireSection);
  });
})();
